import { RFQ, RfqInterface } from './../../../core/quotes/store/quotes.model';
export interface UnitClassInterface {
  id :number;
  name :string;
  baseClass :boolean;
  unitOfMeasures ?:UnitMeasureInterface[];
  baseUnitOfMeasure :UnitMeasureInterface;
}

export interface UnitMeasureInterface {
  id :number;
  unitClassId :number;
  unitClass :UnitClassInterface;
  name :string;
  description :string;
  baseUnit :boolean;
  baseUnitOfMeasure :UnitMeasureInterface;
  conversionFactor :number;
}

export interface UnitConversionRuleInterface {
  id :number;
  baseUnitOfMeasureId :number;
  baseUnitOfMeasure ?:UnitMeasureInterface;
  convertedUnitOfMeasureId :number;
  convertedUnitOfMeasure ?:UnitMeasureInterface;
  conversionFactor :number;
  type :UnitConversionRuleType;
  rfqId :number;
  kitId :number;
  rfq ?:RfqInterface;
  kit ?:any;
  alternateSkus ?:any;
}

export enum UnitConversionRuleType {
  SYSTEM = 'SYSTEM',
  SKU = 'SKU',
  KIT = 'KIT',
}

export enum UnitConversionRuleValue {
  SYSTEM = 'SYSTEM WIDE',
  SKU = 'SKU',
  KIT = 'KIT',
}

export interface OrderedUnitOfMeasureInterface {
  id :number;
}
